import classNames from "classnames";
import React from "react";
import { useState } from "react";
import {
  CurrencyDollarIcon,
  UsersIcon,
  ShoppingCartIcon,
  ArrowRightIcon,
} from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import { MenuContent } from "./menu";
import { BsArrowRightSquare } from "react-icons/bs";
import { useQuery } from "react-query";
import Constants from "../tools/constants.tools";

export const Home = () => {
  const navigate = useNavigate();
  const _menus = useQuery('menus');
  const _users = useQuery('users');
  const _commandes = useQuery('commandes', {
    onSuccess: resp => {
      let prix = 0;
      resp.data.map(item => prix += item.prix)
      setState({...state, revenuTotal: prix})
    }
  });
  const _gyms = useQuery('gyms');

  const [state, setState] = useState({
    revenuTotal: 0
  })


  return (
    <>
      <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        <div className="grid gap-5 md:grid-cols-1 lg:grid-cols-2">
          <DashCard title="Menus" value={_menus.data?.data.length} onClick={() => {}}>
            <DashIcon
              icon={CurrencyDollarIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-indigo-600"
              className="mr-4"
            />
          </DashCard>

          <DashCard title="Utilisateurs" value={_users.data?.data.length} onClick={() => {}}>
            <DashIcon
              icon={UsersIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-red-600"
              className="mr-4"
            />
          </DashCard>
        </div>
        <div className="grid gap-5 md:grid-cols-1 lg:grid-cols-2">
          <DashCard title="Commandes" value={_commandes.data?.data.length} onClick={() => {}}>
            <DashIcon
              icon={ShoppingCartIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-amber-600"
              className="mr-4"
            />
          </DashCard>

          <DashCard title="Revenu total" value={state.revenuTotal} onClick={() => {}}>
            <div className="bg-green-400 rounded-full mr-4 h-11 w-11 flex items-center justify-center">
              <p className="text-white font-bold text-xs ">GNF</p>
            </div>
          </DashCard>
        </div>
      </div>


      <div className="grid pt-5 gap-5 md:grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-2 relative overflow-x-auto w-auto rounded-2xl">
          <MenuContent activeButton={false} />
        </div>  
        <div className="bg-white h-auto rounded-2xl p-5">
          <div className="flex flex-row justify-between items-center">
            <h1 className="text-xl">Commandes</h1>
            <ArrowRightIcon
              className="cursor-pointer text-black h-4 w-4"
              onClick={() => navigate("/dashboard/commande")}
            />
          </div>
          
          <p className="text-gray-400 text-xs">
            Les commandes les plus récentes
          </p>
          <br />
          <div>
            {
              _commandes.isSuccess && _commandes.data?.data.length !== 0
                  ? _commandes.data?.data.map((item, index) => {
                    if(index < 5)
                    return (
                      <div key={item._id} className="flex bg-white shadow-lg p-3 my-3">
                        <img src={Constants.IMAGE_LINK+item.image} alt="pizza" className=" h-12 w-12" />
                        <div className="px-2">
                          <p className="text-black text-bold border-r pr-3">
                            {item.userId.prenom.charAt(0).toUpperCase()+item.userId.prenom.slice(1)+' '+item.userId.nom}
                          </p>
                          <p className="text-gray-600">{item.nom}</p>
                        </div>
                        <div className="flex flex-col justify-end items-end px-2">
                          <p className="text-black text-bold pb-2">{item.prix}</p>
                          <BsArrowRightSquare size={20} />
                        </div>
                      </div>
                    )
                  }
                  )
              : <p className="text-gray-600 text-sm">Aucune commande trouvée</p>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export function DashIcon({
  icon: Icon,
  iconColorClass = "text-purple-600",
  bgColorClass = "bg-purple-100",
  className,
}) {
  const baseStyle = "p-3 rounded-full";

  const cls = classNames(baseStyle, iconColorClass, bgColorClass, className);
  return (
    <div className={cls}>
      <Icon className="w-5 h-5" />
    </div>
  );
}

export function DashCard({ title, value, children: icon, onClick }) {
  return (
    <div
      className="flex items-center bg-white p-5 rounded-2xl cursor-pointer"
      onClick={onClick}
    >
      {icon}
      <div>
        <p className="mb-2 text-sm font-medium text-gray-600">{title}</p>
        <p className="text-lg font-semibold text-gray-700">{value}</p>
      </div>
    </div>
  );
}
